import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./auth/authSlice";
import partsReducer from "./parts/partsSlice";
import usePartsReducer from "./useParts/usePartsSlice";
import membershipReducer from "./membership/membershipSlice";
import contactReducer from "./contact/contactSlice";
import enterpriseSalesReducer from "./enterpriseSales/enterpriseSalesSlice";
import partChatReducer from "./partChat/partChatSlice";
import paymentMethodReducer from "./paymentMethod/paymentMethodSlice";
import dashboardReducer from "./dashboard/dashboardSlice";
import categoriesReducer from "./categories/categoriesSlice";
import aiAssistantReducer from "./aiAssistant/aiAssitantSlice";
import inquriesReducer from "./partInquiry/partInquirySlice";

// Combine all reducers
const reducers = combineReducers({
  auth: authReducer,
  parts: partsReducer,
  useParts: usePartsReducer,
  membership: membershipReducer,
  contact: contactReducer,
  enterpriseSales: enterpriseSalesReducer,
  partChat: partChatReducer,
  paymentMethod: paymentMethodReducer,
  dashboard: dashboardReducer,
  categories: categoriesReducer,
  ai: aiAssistantReducer,
  inquries: inquriesReducer
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"]
};

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, reducers);

// Final rootReducer with reset handling
const rootReducer = (state, action) => {
  if (action.type === "RESET_ALL_SLICES") {
    storage.removeItem("persist:root");
    state = undefined;
  }
  return persistedReducer(state, action);
};

// Configure store
const store = configureStore({
  reducer: rootReducer,
  devTools: import.meta.env.MODE !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export default store;
